"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _get = _interopRequireDefault(require("lodash/fp/get"));
var _curry = _interopRequireDefault(require("lodash/fp/curry"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 *
 * A function which returns a comparison function that extracts values at a
 * certain path, and runs given comparison function on those values.
 *
 * @name compareAtPath
 * @type Function
 * @param {String} path - Name of the path to values
 * @param {Function} func - Comparison function to run on values at specified path
 * @returns {Function} Comparison function
 *
 * @example
 *
 * const people = [
 *  { name: 'Brad', age: 66 },
 *  { name: 'Georgina', age: 35 }
 * ]
 *
 * const sortAscending = (a, b) => a - b
 *
 * const ageComparator = compareAtPath('age', sortAscending)
 *
 * people.sort(ageComparator)
 *
 * // [
 * //   { name: 'Georgina', age: 35 },
 * //   { name: 'Brad', age: 66 },
 * // ]
 *
 */

function compareAtPath(path, func) {
  var getter = (0, _get["default"])(path);
  return function compare(a, b) {
    var _map = [a, b].map(getter),
      _map2 = _slicedToArray(_map, 2),
      aValue = _map2[0],
      bValue = _map2[1];
    return func(aValue, bValue);
  };
}
var _default = (0, _curry["default"])(compareAtPath);
exports["default"] = _default;